import PropTypes from 'prop-types'
import React from 'react'

import GoogleSignIn from '../GoogleSignIn'
import AppleSignIn from '../AppleSignIn'
import FacebookSignIn from '../FacebookSignIn'
import OpenAthensSignIn from '../OpenAthensSignIn'
import './styles.css'

/**
 * SPEC-101 D9 (Pedro): the social sign-in stack is the one production
 * already uses: Google's own button, then Apple, Facebook and (outside
 * checkout) OpenAthens, full width. Every auth screen renders it from here.
 *
 * On a create-account screen (`signUp`) each request carries the newsletter
 * answer and counts as a sign-up for analytics; the dispatchers read both
 * from these props.
 */
function SocialButtons({ signUp = false, showOpenAthens = false, ...props }) {
  const buttonProps = { ...props, signUp }
  return (
    <div className="social-logins">
      <GoogleSignIn {...buttonProps} />
      <AppleSignIn {...buttonProps} />
      <FacebookSignIn {...buttonProps} />
      {showOpenAthens && <OpenAthensSignIn />}
    </div>
  )
}

SocialButtons.propTypes = {
  signUp: PropTypes.bool,
  // D3/D4: school and library members sign in from /login and /register,
  // never from checkout
  showOpenAthens: PropTypes.bool,
  marketingConsent: PropTypes.bool,
  inCheckout: PropTypes.bool,
  isMobile: PropTypes.bool,
  location: PropTypes.object
}

export default SocialButtons
